import { MapTo } from '@adobe/cq-react-editable-components';

import Loadable from '../../../../utils/loadable';

const cart = Loadable(() => import('../../containers/web/cart'));
export default MapTo('vcg/components/soe-home/react/cart')(cart);
